import { isLocalEnv } from 'constants/domains';
import { EMBED_AI_OPENED_FF } from 'modules/ai/constants/embedAiStorage';

export const hasEmbedAiIntroPlayed = (): boolean => {
  if (isLocalEnv) {
    return false;
  }
  try {
    return localStorage.getItem(EMBED_AI_OPENED_FF) === 'true';
  } catch {
    return true;
  }
};

export const markEmbedAiIntroPlayed = (): void => {
  if (isLocalEnv) {
    return;
  }
  try {
    localStorage.setItem(EMBED_AI_OPENED_FF, 'true');
  } catch {
    // ignore quota / private mode
  }
};

export const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};
